<div fxLayoutAlign="start center" fxLayout="column" class="container">
  <div fxLayout="row" fxLayoutAlign="center" class="error-message-container">
    <h4>{{ errorMessage.errorMessage }} <small *ngIf="errorMessage?.statusCode">{{ errorMessage.statusCode }}</small></h4>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center">
    <p>{{ errorMessage.detailMessage }}</p>
  </div>
</div>
